import React from 'react';
import { Box, Chip, Tooltip } from '@mui/material';

type ChipColor = 'success' | 'warning' | 'error' | 'default';

interface StatusConfig {
  label: string;
  color: ChipColor;
}

const STATUS_CONFIG: Record<string, StatusConfig> = {
  active:              { label: 'Активних',   color: 'success' },
  pending:             { label: 'Очікує',      color: 'warning' },
  rejected:            { label: 'Відхилено',  color: 'error'   },
  terminated:          { label: 'Завершено',  color: 'default' },
  archived_by_client:  { label: 'В архіві',   color: 'default' },
};

interface Props {
  connectionsByStatus: Record<string, number>;
}

export const ConnectionsByStatusChips: React.FC<Props> = ({ connectionsByStatus }) => {
  const entries = Object.entries(connectionsByStatus).filter(([, count]) => count > 0);

  if (entries.length === 0) return <>—</>;

  return (
    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
      {entries.map(([status, count]) => {
        const cfg = STATUS_CONFIG[status] ?? { label: status, color: 'default' as ChipColor };
        return (
          <Tooltip key={status} title={cfg.label}>
            <Chip
              label={count}
              color={cfg.color}
              size="small"
              variant="outlined"
              sx={{ minWidth: 28, height: 20, fontSize: 11, '& .MuiChip-label': { px: 0.75 } }}
            />
          </Tooltip>
        );
      })}
    </Box>
  );
};
